/**
 * WCC360 v2 — Part 2 archetype tally.
 *
 * The 8 archetypes are the ONLY ones. No aliases, no families, no synonyms.
 * See project rules: Builder · Thinker · Creator · Connector · Organizer ·
 * Leader · Caregiver · Advocate.
 */
export const ARCHETYPES = [
  "Builder", "Thinker", "Creator", "Connector",
  "Organizer", "Leader", "Caregiver", "Advocate",
] as const;

export type Archetype = typeof ARCHETYPES[number];

export type ArchetypeVector = Record<Archetype, number>;

export function emptyVector(): ArchetypeVector {
  return {
    Builder: 0, Thinker: 0, Creator: 0, Connector: 0,
    Organizer: 0, Leader: 0, Caregiver: 0, Advocate: 0,
  };
}

/** Add weighted deltas from one signal into a running tally. */
export function addSignal(
  vector: ArchetypeVector,
  deltas: Partial<Record<Archetype, number>>,
  weight = 1,
): ArchetypeVector {
  const next = { ...vector };
  for (const [k, v] of Object.entries(deltas) as [Archetype, number][]) {
    next[k] = (next[k] ?? 0) + v * weight;
  }
  return next;
}
